import React from 'react'
import { AppBar, UserMenu } from "react-admin";
import { withStyles } from '@material-ui/core/styles'
import {  makeStyles } from '@material-ui/core';
import Avatar from "@material-ui/core/Avatar";
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import {
  Button,
} from '@mui/material';
import Person from '@mui/icons-material/Person';
import { Link } from 'react-router-dom';

import { PersonPinCircleOutlined } from '@material-ui/icons';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import SdStorageIcon from '@mui/icons-material/SdStorage';
import Add from '@material-ui/icons/Add';

import { isMobile } from 'react-device-detect';

const styles = {
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  spacer: {
    flex: 1,
  },
}
const useStyles = makeStyles(theme => ({
  menuItem: {
    color: theme.palette.text.secondary
  },
  avatar: {
    height: 30,
    width: 30
  },
  icon: { minWidth: theme.spacing(5) },
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

export const RenderIconSwitch = (prop) => {
  let param = prop.data
  // document.getElementById("buttonCreateContact").style.visibility = "hidden";
  switch (param.type) {
    case 'contact':

      return (
        <div style={{ padding: "30px" }}>
          <PersonPinCircleOutlined />

          <span>{param.customData.name}</span>
          <p>{param.customData.phoneNumbers.map(a => a.number + "  ,  ")}</p>

          <div style={isMobile ? {} : { display: 'flex' }}>

            <Button
              startIcon={<Add style={{ paddingLeft: "8px" }} />}
              color="primary" variant="contained"
              component={Link}
              style={{ margin: "20px" }}

              to={{
                pathname: '/need/create',
                state: { record: { contactId: param.content.id, contactRefNum: param.content.label } },
              }}
            >
              درخواست
            </Button>
            <Button
              startIcon={<Add style={{ paddingLeft: "8px" }} />}
              color="primary" variant="contained"
              component={Link}
              style={{ margin: "20px" }}

              to={{
                pathname: '/clue/create',
                state: {
                  record: {
                    phoneNumber: param.customData.phoneNumbers[0]?.number,
                    users: param.customData.users,
                    contactName: param.customData.name,
                    contactId: param.content.id, contactRefNum: param.content.label
                  }
                },
              }}
            >
              سرنخ
            </Button>

            <Button
              startIcon={<Add style={{ paddingLeft: "8px" }} />}
              color="primary" variant="contained"
              component={Link}
              style={{ margin: "20px" }}

              to={{
                pathname: '/reminder/create',
                state: {
                  record: {
                    phoneNumber: param.customData.phoneNumbers[0]?.number,
                    users: param.customData.users,
                    contactName: param.customData.name,
                    contactId: param.content.id, contactRefNum: param.content.label
                  }
                },
              }}
            >
              یادآوری
            </Button>
          </div>
        </div>
      )
    case 'need':
      return <LiveHelpIcon />
    case 'storage':
      return <SdStorageIcon />
    default:
      return 'foo';
  }
}


const MyAppBar = withStyles(styles)(({ classes, ...props }) => {

  return (
    <AppBar userMenu={<MyUserMenu icon={<MyCustomIcon />} />} {...props}>
      {/* <Typography
            variant="title"
            color="inherit"
            className={classes.title}
            id="react-admin-title"
        /> */}
      <span className={classes.spacer} />
      {/* <IconButton color="inherit" >
            <BackIcon/>
        </IconButton> */}
      {/* <Button
      id="buttonCreateContact"
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/contact/create',
        state: { record: {  } },
      }}
    >
      ایجاد  مخاطب
    </Button> */}
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        ایجاد  مخاطب
      </Button> */}
    </AppBar>
  )
}
)
const MyUserMenu = props => (
  <UserMenu {...props}>
    <ProfileMenu />
    {/* <SidebarToggleButton /> */}
  </UserMenu>
);

const MyCustomIcon = () => {
  const classes = useStyles();
  return (
    <>
      <Avatar
        className={classes.avatar}
        src="profile.png"
      />
      {!isMobile ? <span style={{ marginRight: 8 }}><b>{localStorage.getItem("username")}</b></span> : null}

    </>
  );
};

const ProfileMenu = React.forwardRef((props, ref) => {
  return (
    <MenuItem
      ref={ref}
      component={Link}
      // It's important to pass the props to allow MUI to manage the keyboard navigation
      {...props}
      to="#"
    >

      <ListItemIcon>
        <div>
          <Person />
          {localStorage.getItem("username")}
        </div>

      </ListItemIcon>

    </MenuItem>
  );
});

export default MyAppBar
